export default {
  name: "lululemon",
  appId: "wx8ecb614bed6e2d78",
  wechatId: "216",
  baseUrl: "https://egoldengoose.cn/",
};
